"use client";

import { c as _c } from "react/compiler-runtime";
import { useMemo, useCallback } from "react";
import { useRouter } from "next/navigation";
import type { DealWithRelations } from "@/lib/deals/types";
import { sortDealsByUrgency } from "@/lib/deals/status-config";
import type { DealPerspective } from "@/lib/deals/status-config";
import { UnifiedDealCard } from "@/components/deals/UnifiedDealCard";
interface DealListFlatProps {
  deals: DealWithRelations[];
  role: DealPerspective;
  userId: string;
}
export function DealListFlat(t0) {
  const $ = _c(17);
  const {
    deals,
    role,
    userId
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== deals || $[1] !== role) {
    t1 = sortDealsByUrgency(deals, role);
    $[0] = deals;
    $[1] = role;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const sorted = t1;
  let t2;
  if ($[3] !== router) {
    t2 = () => router.refresh();
    $[3] = router;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleRefresh = t2;
  if (sorted.length === 0) {
    return null;
  }
  let t3;
  if ($[5] !== handleRefresh || $[6] !== role || $[7] !== sorted || $[8] !== userId) {
    let t4;
    if ($[10] !== handleRefresh || $[11] !== role || $[12] !== sorted.length || $[13] !== userId) {
      t4 = (deal, index) => <UnifiedDealCard key={deal.id} deal={deal} perspective={role} userId={userId} dealNumber={index + 1} totalDeals={sorted.length} onRefresh={handleRefresh} />;
      $[10] = handleRefresh;
      $[11] = role;
      $[12] = sorted.length;
      $[13] = userId;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = sorted.map(t4);
    $[5] = handleRefresh;
    $[6] = role;
    $[7] = sorted;
    $[8] = userId;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[15] !== t3) {
    t4 = <div className="space-y-3">{t3}</div>;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
}